module.exports = {
  vantText: {
    confirm: 'confirm',
    cancel: 'cancel',
  },
  center: {
    title: 'Home',
    logout: 'Log Out',
    coinDetail: 'Manage Restaurant',
    coinDetail1: 'My Bill',
    coinTitle: 'My Points',
    recharge: 'Purchase',
    cusservice: 'Customer Service',
    relativePhone: "Change Phone Number",
    myintroPeople: "My Introducer",
    myClient: "My Client",
    platformList: 'My Platform List',
    platformInfo: 'My Platform Information',
    chooseL: 'Language',
    chooseLang: "Select",
    message: 'Data Retrieval Failed',
    tip: 'Note: only 1x user can login at the same time',
    back: 'Log Out',
    isBack: 'Log out?'
  },
  ShopList: {
    title: 'Manage Restaurant',
    message: 'Data Retrieval Failed',
    addshop: 'New Shop',
    add: 'New',
    enter: "Enter",
    edit: 'Edit',
    copy: "Copy",
    delete: "Delete",
    setting: "Store settings",
    RechargeAmountSetting: "Recharge amount setting",
    addRechargeAmount: "Add recharge amount",
  },
  member: {
    number: "Serial Number",
    name: "name",
    nameplaceholder: "Please enter a name",
    PaymentAmount: "Payment amount",
    RechargeAmount: "Recharge amount",
    Discount: 'Discount',
    PaymentAmountplaceholder: "Please enter the payment amount",
    RechargeAmountplaceholder: "Please enter the recharge amount",
    Discountplaceholder: 'Please enter a discount',
    Switch: "Switch",
    order_number: "Serial Number",
    order_numberPlaceholder: "Please enter the serial number",
    Operate: "Operate",
    ConfirmWhetherToDelete: "Confirm whether to delete",
  },
  NewShop: {
    title: "Restaurant Set Up",
    name: "Name",
    address: "Address",
    pic: "Photo",
    phone: "Phone Number",
    startTime: "Open Time",
    chooseStartTime: "Select ",
    endTime: "Closing Time",
    chooseEndTime: "Select ",
    timeLimit: "Serving Time Limit",
    cookTime: "Production Time Limit",
    intro: "Store Introduction",
    chooseL: 'Store language',
    inputIntro: "Input",
    message: 'Data Retrieval Failed',
    toast: 'Fill In All Information',
    minute: 'Minutes',
    hour: 'Hour',
    shopType: 'Shop Type', //店铺类型
    chooseShopType: 'Select'
  },
  DishDetail: {
    title: "Details",
    specifications: 'Options',
    tasteNotes: 'Flavor',
    message: 'Data Retrieval Failed',
  },
  Dishes: {
    title: 'Please select',
    noneGoods: 'No product',
    message: 'Data Retrieval Failed',
    pachage: 'Set',
  },
  PackageDetail: {
    title: 'Details',
    specifications: 'Options',
    tasteNotes: 'Flavor',
    message: 'Data Retrieval Failed',
    chooseSpecs: 'Options',
    note: 'Flavor',
    remark: 'Remark',
    inputRemark: "Input Remark",
    certain: 'Confirm',
    addToCart: 'Add To Cart',
  },
  EditBook: {
    title: 'Booking',
    text: 'Restaurant Not Launched Yet',
    codeText: 'Booking QR Code',
    copy: 'Copy The Link',
    refresh: 'Refresh QR Code',
    copyBtn: 'Copy',
    refreshBtn: 'Refresh',
    message: 'Data Retrieval Failed',
    bookSwitch: 'Book Display',
    takeawaySwitch: 'Takeaway Display',
    menuSwitch: 'Menu Display',
    pickSwitch: 'pickup Display',
  },
  EditDish: {
    title: "Product settings",
    category: 'Category',
    noChoose: "Product Hidden When None Selected",
    cookName: 'Main name',
    enName: 'Sub name',
    inputName: "Input",
    pic: "Photo",
    price: "Price",
    status: 'Choose One',
    oldPrice: 'Original Price',
    inputOldPrice: 'X.XX',
    newPrice: 'Special Price',
    inputNewPrice: "X.XX",
    commend: "Recommend",
    prefer: "Preference",
    severce: "Service Duration",
    intro: "Description",
    inputIntro: "Input",
    noChoose1: 'Hidden When None Selected',
    message: 'Data Retrieval Failed',
    toast: 'Please Fill In All The Information',
    ingredients: 'Product',
    checkbox: "Multiple choice",
    DisplaySwitch: "Display switch",
    prompt: "Not within the same category, invalid sorting"
  },
  EditPackage: {
    title: "Package Settings",
    packageName: "Name of Set",
    enName: 'Sub name',
    inputPackageName: "Input",
    pic: ' Photo',
    price: " Price",
    OldPrice: "Original Price",
    inputOldPrice: "Input",
    newPrice: "Special Price",
    inputNewPrice: "Input ",
    commend: "Recommend",
    intro: "Description",
    inputIntro: "Input",
    illustration: 'Description',
    inputIllustration: 'Input',
    addCook: "Add Product",
    text: "First Add Tag, Then Add Product, Then Set Price",
    inputCategory: "Input Tag",
    message: 'Data Retrieval Failed',
    pleaseInputName: 'Dish Name',
    toast: 'Fill In All Information',
    delCategory: 'Delete Tag',
    isDelCategory: 'Delete This Tag?',
    chooseDelLabel: 'Choose Category To Delete',
    chooseMoveLabel: 'Choose Category To Move'
  },
  EditShop: {
    title: "Restaurant",
    storeSetting: 'Store Function Settings',
    name: "Name",
    inputName: "Input",
    address: "Address",
    inputAddress: "Input",
    pic: "Store Photo",
    advertising_images: "Advertising images",
    phone: "Phone",
    inputPhone: "Input",

    startTime: "Open Hours",
    chooseStartTime: "Select",
    endTime: "Closing Time",
    chooseEndTime: "Select",

    startAfterTime: "Start lunch break",
    chooseStartAfterTime: "Select",
    endAfterTime: "End of lunch break",
    chooseEndAfterTime: "Select",

    cookTime: "Serving Time",
    cookingTime: "Production Time",
    intro: "Introduction",
    inputIntro: "Input",
    message: 'Data Retrieval Failed',
    toast: 'Fill In All Information',
    minute: 'Minutes',
    chooseL: 'Store language',
    currency: 'Store currency',
    chooseCurrency: 'Select',
    color: "Store color",
    inputColor: "Select",

    fail_time: "Timeout period",
    inputFail_time: "Input",
    isQuick: 'Quick order',
    isServiceCharge: 'Seat ordering - service fee',
    serviceCharge: 'Service charge',
    isDiscountFee: 'Seat ordering - discount fee',
    isFloat: 'Retention Amount Precision',
    isAdditional: 'Regional surcharges',
    amountExempt: 'Achieve a specified amount to waive regional surcharges',
    amount: 'Please enter the amount',
  },
  EditTable: {
    title: "Seat Settings", //区域人数设置
    peopleNum: 'Persons',
    num: 'Persons',
    certain: 'Modify Settings',
    certainBtn: 'Confirm',
    copy: ' Copy The Link',
    screenQRcode: 'Show QR Code On Screen',
    refresh: 'Refresh QR Code',
    lineQRcode: 'QR Code For Queue',
    message: 'Data Retrieval Failed',
    copyScuess: 'Copied',
    // 新增
    screenLink: 'Big screen link'
  },
  MenuRank: {
    title: "Product Ranking",
    text1: 'From',
    text: 'to',
    price: "Price",
    rank: '',
    cookName: 'Dish Name',
    price1: 'Price',
    num: 'Quantity',
    money: "Price",
    portion: '',
    portionNum: "Number Of Plates",
  },
  NewDish: {
    title: "Product Settings",
    cookName: 'Name',
    enName: 'Sub name',
    inputName: "Input",
    pic: "Photo",
    price: "Price",
    oldPrice: "Original Price",
    inputOldPrice: "Input Old Price",
    newPrice: "Special Price",
    inputNewPrice: "Input New Price",
    commend: "Recommendation",
    setPrefer: "Preference",
    category: "Category",
    message: 'Data Retrieval Failed',
    toast: 'Fill In All Information',
  },
  NewPackage: {
    title: "Package Settings",
    packageName: "Set Name",
    enName: 'Sub name',
    inputPackageName: "Input",
    pic: "Photo",
    price: "Price",
    oldPrice: "Original Price",
    inputOldPrice: "Input",
    newPrice: "Special Price",
    inputNewPrice: "Input",
    commend: "Recommendation",
    message: 'Data Retrieval Failed',
    toast: 'Fill In All Information',
  },
  NoData: {
    buy: 'Please Purchase Function',
    noData: 'No Data',
    sale: 'Contact Sales Support'
  },
  PackageDish: {
    title: 'Product Settings',
    chooseCook: 'Select Product',
    compensationPrice: "Price Difference",
    inputMoney: "Input",
    cancel: "Cancel",
    cook: "Product",
    save: 'Save',
    message: 'Data Retrieval Failed',
    inputCompensationPrice: 'Input price difference',
    pleaseChooseCook: 'Select Product',
    del: 'Delete',
    isDel: 'Delete Selected Product?',
    chooseDelCategory: 'Select Category To Delete',
  },
  ServiceBill: {
    title: "Bill",
    time: 'Time',
    shopName: 'Name of Restaurant',
    num: 'Points Spent',
    message: 'Data Retrieval Failed',
    ActivateStore: 'publish',
    RechargePoints: 'Recharge'
  },
  SetMenu: {
    title: "Product List Settings",
    category: "Category",
    inputCategory: "Input",
    prefer: "Preference",
    inputPrefer: "Input",
    cook: "Products",
    inputCookName: "Input",
    package: "Set",
    inputPackageName: "Input",
    show: "Sort",
    name: "Name",
    showSwitch: "Show",
    perferSwitch: "MultiSelect",
    price: "Price",
    edit: "Actions",
    message: 'Data Retrieval Failed',
    toast: 'Fill In All Information',
    del: 'Delete Size',
    isDel: 'Delete Selected Size?',
    chooseDelCategory: 'Please select the option to delete',
    delCategory: 'Delete Category',
    isDelchooseCategory: 'Delete Selected Category?',
    delCook: 'Delete Product',
    isDelCook: 'Delete Selected Product?',
    delPackage: 'Delete Set',
    isDelPackage: 'Delete Selected Set?',
    batch: "Batch binding",
    Selected: "Selected",
    term: "term",
    batchClass: "Batch binding categorys",
    batchPerfer: "Batch binding preferences",
    batchPrice: "Batch binding price",
    batchClassTitle: "Please select a category for bulk binding",
    batchPerferTitle: "Please choose the preference for bulk binding",
    batchPriceTitle: "Please enter the price for bulk binding",

  },
  SetPerfer: {
    pleaseAdd: "Please Add Size",
    message: 'Data Retrieval Failed',
    toast: 'Fill In Information',
    del: 'Delete Size',
    isDel: 'Delete Selected Size?',
    chooseDelCategory: 'Select Category To Delete',
  },
  ShopStatus: {
    title: "Restaurant Status",
    publishsShop: 'Publish Restaurant',
    servicePoint: 'Point Balance',
    count: 'Points',
    cancel: 'Cancel',
    certain: 'Confirm',
    note: "Notes",
    p1: 'Days Paid Are Only Applied To This Restaurant',
    p2: 'No Refunds',
    p3: 'If This Restaurant Is Deleted, There Is No Return For The Remaining Days',
    p4: 'The Final Interpretation Of The Notes Is Subject To Egg Carton Studios',
    shopType: 'Restaurant Status',
    inActive: 'Inactive',
    active: 'Active',
    canUse: 'Remaining',
    day: 'Days',
    message: 'Data Retrieval Failed',
    shopOnLine: 'Publish Restaurant',
    text: 'Your Points Will Be Deducted For This Restaurant',
    severceCount: 'Points',
    InsufficientServicePoints: 'Insufficient Points'
  },
  ShopSet: {
    comment: "Note",
    deliveryTime: "Delivery Time",
    deliveryDate: "Delivery Date",
    PickUpDate: "Pick-Up Date",
    PickUpTime: "Pick-Up Time",
    title: "Restaurant Functions",
    manage: "Manage",
    set: "Set",
    report: "Report",
    statistical: "Statistical",
    editShop: "Restaurant Management",
    setMenu: "Product Management",
    setSeat: "Table Management",
    staffList: "Staff Management",
    shopStatus: "Activated Status",
    payEdit: "Payment Account Settings",
    paySet: "Payment Method",
    cookInfo: "Kitchen Function",
    editTable: "Set Queue",
    editBook: "Homepage",
    monthReport: "Monthly Sales Report",
    weekReport: "Weekly Sales Report",
    dayReport: "Daily Sales Report",
    customerTime: "Customer Volume Report",
    menuRank: "Product Ranking",
    tableRank: "Table Ranking",
    staffReport: "Staff Report",
    cookTime: "Production Time",
    publishsShop: 'Publish',
    servicePoint: 'Point Balance',
    take_name: 'Consignee Name',
    take_tel: 'Telephone number',
    take_address: 'Receiving address',
    is_show: 'Show or not',
    is_write: 'Required',
    is_print: 'Print',
    count: 'Point',
    cancel: 'Cancel',
    certain: 'Confirm',
    note: "Note",
    p1: 'Purchased Usage Days Are Limited To Current Restaurant Use',
    p2: 'No Refunds',
    p3: 'If This Restaurant Is Deleted, There Is No Return For The Remaining Days',
    p4: 'The Final Interpretation Of The Notes Is Subject To Egg Carton Studios',
    inActive: 'Inactive',
    active: 'Active',
    canUse: 'Remaining',
    day: 'Days',
    message: 'Data Retrieval Failed',
    del: 'Delete',
    isDelShop: 'Delete This Restaurant?',
    shopOnLine: 'Publish',
    text: '',
    severceCount: ' Points Will Be Deducted?',
    InsufficientServicePoints: 'Insufficient Points',
    // 新增，需要修改的
    phoneList: 'Customer infomation', //Phone number list
    cookPrinting: ' kitchen printing function',
    ticketPrinting: ' ticket printing function',
    autoPrint: 'Auto print',
    printerSet: 'Printer',
    stockList: 'Inventory report',
    Ingredients: 'Product',
    IsItOpen: 'Store Operations',
    noIngredients: 'No product',
    isOut: 'Table QR Code become Pickup Function',
    IsPay: 'Table QR code need pay first',
    IsSkip: 'Table QR Code need to input # customer',
    IsMerge: 'Print according to order',
    clear: 'Auto clean table after payment',
    member: "Member recharge",
    auto: "Takeaway automatic printing",
    seat: "Small ticket QR code",
  },
  SetSeat: {
    title: "Table Settings",
    floor: 'Floor',
    seat: 'Seats',
    downLoadQRcode: 'Download QR Code', //全部下载
    floorName: "Floor Name",
    submit: 'Submit',
    tableName: 'Table Name',
    inputSeatNum: "Input Table Name",
    setNum: 'Number Of Seats',
    inputNum: "Input",
    inputSeat: "Input",
    QRCode: 'QR Code',
    message: 'Data Retrieval Failed',
    inputFloorName: 'Input Floor Name.',
    delFloor: 'Delete Floor',
    isDelFloor: 'Delete Selected Floor?',
    toast: 'Fill In All Information',
    delSeat: 'Delete Seat',
    isDelSeat: 'Delete Selected Seat?',
    pleaseInputSeatNum: 'Fill In Table Name',
    UsurpedRefreshQRcode: 'Refresh When QR Code Is Usurped',
    refresh: 'Refresh',
    refreshTip: 'After confirming the refresh, the original QRCode will be permanently invalid',
    savePrint: 'Save And Print QR Code ',
    download: 'Download',
    copy: 'Copy'
  },
  CookInfo: {
    copy: 'Copy The Link',
    loginLink: "Login Link",
    refresh: 'Refresh QR Code',
    message: 'Data Retrieval Failed',
    copyScuess: 'Copied',
  },
  StaffList: {
    title: "Staff Settings",
    account: 'Account:',
    message: 'Data Retrieval Failed',
  },
  NewStaff: {
    title: "New Staff",
    name: "Name",
    placeholderName: "Name",
    gender: "Gender",
    placeholdergender: "Gender",
    birth: "Birthday",
    placeholderBirth: "Birthday",
    phone: "Phone Number",
    placeholderPhone: "Phone Number",
    workTime: "Entry Time:",
    placeholderWorkTime: "Entry Time",
    post: "Post",
    placeholderPost: "Post",
    password: "Password",
    placeholderPassword: "Password",
    man: 'Male',
    woman: 'Female',
    staff: 'Waiter',
    message: 'Data Retrieval Failed',
    toast: 'Fill In All Information.',
  },
  EditStaff: {
    link: "Link To Login",
    copy: 'Copy The Link',
    refresh: 'Refresh QR Code',
    copyBtn: 'Copy',
    refreshBtn: 'Refresh',
    submit: 'Submit',
    delStaff: 'Delete Staff',
    isDelStaff: 'Delete Staff?',
    success: 'Copied',
  },
  checkNum: {
    title: "Phone Number Verification",
    text: 'To Protect Your Account, To Proceed Please Verify Identity',
    text2: 'Verification Code Will Be Sent To',
    inputSMS: 'Input',
    SMS: 'SMS Verification',
    retrieve: 'Resend',
    next: 'Next',
    message: 'Data Retrieval Failed',
    pleaseInputSMS: 'Input Verification Code'
  },
  UpdateNum: {
    title: "New Phone Number",
    text: 'To Protect Your Account, New Phone Number Has To Be Verified',
    input: "Please Input User Name Or Phone Number",
    inputSMS: "Input The Code",
    SMS: 'SMS Verification',
    retrieve: 'Resend',
    certain: 'Confirm',
    message: 'Data Retrieval Failed',
    inputPhone: 'Please Fill In Phone Number',
    fail: 'Verification Expired',
    toast: 'Fill In All Information',
  },
  ContactUs: {
    contact: 'Contact Salesperson',
    area: 'District',
    name: 'Name',
    phone: 'Phone Number',
    hongkong: 'Hong Kong',
    taiwan: 'Taiwan',
    zhuhai: 'Zhuhai',
    shanwei: 'Shanwei',
    shenzhen: 'Shenzhen',
    shantou: 'Shantou',
    dongguan: 'Dongguan',
    guilin: 'Guilin',
    fuzhou: 'Fuzhou',
    lin: 'Mr. Lin',
    tian: 'Mr. Tin',
    chen: 'Mr. Chen',
    chan: 'Mr. Chan',
    qiu: 'Mr. Qiu',
    liu: 'Mr. Liu',
    wang: 'Mr. Wang',
    shi: 'Mr. Shi',
    misschen: 'Miss Chen'
  },
  CookTime: {
    title: "Production Time",
    text1: 'From',
    text: 'To',
    longTime: 'Longest',
    name: 'Dish Name',
    time: 'Time',
    averageTime: 'Average',
    shortTime: 'Shortest',
  },
  CustomerTime: {
    title: "Customer Period",
    text1: 'From',
    text: 'To',
    time: 'Time',
    t: 'T',
    peoopleNum: 'Customer Nos',
    people: '',
    num: 'Number',
  },
  DayReport: {
    export: "Export",
    title: "Daily Sales Report",
    dateTime: "Date:",
    ticket: "Serial Number",
    num: "Table Number",
    peoopleNum: 'Customer Nos',
    price: 'Price',
    people: '',
    none: 'No Data',
  },
  StockReport: {
    title: "Monthly inventory report",
    yTitle: "Annual inventory report",
    dTitle: 'Daily inventory report',
    y: 'Year',
    d: 'Day'
  },
  MonthDetail: {
    month: 'Month',
    date: 'Day',
    peoopleNum: 'Customer Nos',
    price: 'Price',
  },
  MonthReport: {
    title: "Monthly Sales Report",
    month: 'M',
    m: 'Month',
    peoopleNum: 'Customer Nos',
    price: 'Sum',
    money: 'Sum(thousand)'
  },
  StaffReport: {
    title: "Staff Report",
    text1: 'From',
    text: 'To',
    reserve: 'Reservation',
    rank: 'Rank',
    name: 'Name',
    num: 'Quantity',
    one: '',
    order: "Orders Taken",
    dishes: "roduct Served",
    clean: "Tables Cleaned",
    settleAccounts: "Bills Checked",
    type: 'Type',
    out: 'Ex warehouse',
    enter: 'Warehousing'
  },
  TableRank: {
    title: "Table Ranking",
    text1: 'From',
    text: 'To',
    amountOfMoney: "Sum",
    peoopleNum: 'Customer Nos',
    people: '',
    rank: '',
    num: "Table Number",
    price: 'Price',
    amount: 'Amount',
  },
  WeekDetail: {
    text: 'The',
    week: 'Week',
    date: 'Day',
    amountOfMoney: "Sum",
    peoopleNum: 'Customer Nos',
    people: 'People',
    weekReport: 'Weekly Sales Report',
    day: 'Day',
    money: 'Sum(thousand)',
    prev: 'last week',
    next: 'next week',
  },
  WeekReport: {
    title: "Weekly Sales Report",
    weeks: 'Week',
    weekday: 'Date',
    peoopleNum: 'Customer Nos',
    amountOfMoney: "Sum",
    money: 'Sum(thousand)',
  },
  payMethod: {
    method: 'Payment Method',
    card: 'credit card',
    cash: 'cash',
    other: 'other',
    totalprice: 'Price',
  },
  Login: {
    title: "Flexible Convenient Menu Ordering System",
    account: "Account/Phone",
    password: "Password",
    login: 'Login',
    forgetPassword: 'Forgot Password?',
    register: 'Register',
    p1: "Cost of Platform = 1 Main Dish",
    p2: "Ready To Use Only = Preparing 1 Meal’s Time",
    p3: "Increase Efficiency And Profit",
    p4: "Step 1: Setup Table # and Product",
    p5: "Step 2: Connect With Staff Mobile",
    p6: "Step 3: Start Operation",
    p7: "Boss: Hire Less 2 Waiters By Using This Platform!",
    p8: "Waiter: Ordering and Payment Are Clear.  Avoid Mistakes",
    p9: "Chef:  Increase Customer.  Now Too Busy!",
    p10: "Please Contact Our Sales Team and Get Discount Now!",
    contactUs: 'Contact Us',
    toast: 'Enter Phone Number and Password',
    title1: 'Convenience',
    title2: 'Scan code to order',
    title3: 'Automatic order',
    title4: 'Make catering management simple',
    intro1: 'It’s easy to register and you can order food online. There is no need for phone calls to take orders and the order details are clear.',
    intro2: 'You can scan the code to order with the convenient point and scan code, reduce service manpower, and complete smart and convenient ordering.',
    intro3: 'Orders are issued automatically in the cloud within 24 hours, and new orders will be printed directly without fear of missing orders.',
    intro4: 'No APP! Complete O2O integration! Single product sales analysis! Check the store status in real time! Integrate diversified mobile payment, 24 hours a day to receive orders! Through the rich combination of solutions and complete functions, the convenient point function is unparalleled, allowing you to manage your catering business more easily.',
  },
  ForgetPassword: {
    title: "Forgot Password?",
    areaName: "Area Code",
    inputPhone: "Phone Number",
    SMS: 'SMS Verification',
    inputSMS: "Input The Code",
    setNewPassword: "Set Password",
    certainPassword: "Re-enter The Password",
    submit: 'Submit',
    inputAreaNameAndPhone: 'Please enter area code and phone number!',
    getSMSkey: 'Please get the verification code first',
    toast: 'Fill In All Information',
    message: 'Data Retrieval Failed',
    repasswordJudge: 'Inconsistent passwords'
  },
  Register: {
    title: "Register",
    name: "User Name",
  },
  phoneList: {
    title: 'Phone Number List',
    name: 'Name',
    phone: 'Phone Number',
    noPhone: 'No Phone Number'
  },
  CustomerList: {
    title: 'Customer List',
    noCustomer: 'No Customer',
  },
  Pay: {
    type: 'Payment Method',
    selectType: 'Select',
    id: ' Account/Client ID',
    inputId: 'Input',
    secret: 'Secret Key',
    inputSecret: 'Input',
    code: 'Store code',
    inputCode: 'Please enter your store code',
    file: 'Merchant private key file',
    delete: 'Delete',
    isDelete: 'Do You Want To Delete This Payment Method?',
    create: ' Create Payment Method',
  },
  bindCode: {
    title: 'Bind QR code',
    link: 'Link',
    inputLink: 'Please enter the link',
    bind: 'Bind'
  },
  printerSet: {
    name: 'Printer',
    title: 'Printer Set',
    order: 'Order Printer',
    queue: 'Queue Printer',
    kitchen: 'Kitchen Printer',
    printerBrand: 'Printer Brand',
    printerSN: 'Printer Number',
    printerKey: 'Printer ID',
    testPrint: 'Test Print',
    testTip: 'Please add a printer first!',
    merge: 'Kitchen Printer: combine into 1 slip',
    del: 'Delete',
    isDelPrint: 'Whether to delete this printer',
    ptitle: 'title',
    tagTitle: 'Style label',
    remark: 'remarks',
    startlabel: 'Comment start character',
    endlabel: 'Comment end character',
  },
  print: {
    name: 'Print style',
    kitchen: 'Back kitchen list',
    cash: 'Cash register',
    order: 'Check out',
    handover: 'Handover',
    addmenu: 'Add menu',
    title: 'Title',
    stand: 'Stand',
    number: 'Order #',

  },
  order: {
    title: 'Order Detail',
    ticket: 'Pickup #',
  },
  platform: {
    platformSearch: 'Search platform',
    addPlatform: 'Create platform profile',
    editPlatform: 'Edit platform information',
    deleteP: 'Delete platform information',
    isDeleteP: 'Whether to delete the current platform information',
    image: 'Store Picture',
    code: 'QR code',
    platCode: 'Platform QR code',
    platLink: 'Platform link',
    link: 'Link',
    address: 'District surcharge',
    createAdd: 'Create regional surcharge',
    editAdd: 'Edit regional surcharge',
    itemInfo: 'Inventory management',
    delete: 'Delete area surcharge',
    isDelete: 'Whether to delete the current area surcharge',
    name: 'name',
    platname: 'Platform name',
    platImage: 'Platform picture',
    price: 'price',
    inputPlatName: 'Please enter a platform name',
    inputName: 'Please enter a name',
    inputPrice: 'Please enter the price',
    inputLink: 'Please enter the link',
    platInputLink: 'Please enter platform link',
    successtips: 'Copy succeeded',
    errtips: 'The browser does not support automatic replication',
    warehousing: 'Warehousing list',
    issueList: 'Issue list',
    receiptSet: 'Consignee information',
    shopList: 'Shop list',
    ForceSurcharge: 'Force district surcharge',

  },
  itemInfo: {
    name: 'Item name',
    number: 'Item quantity',
    company: 'Item unit',
    exWarehouse: 'Ex warehouse',
    exWarehouseReason: 'Ex-warehouse Reason',
    warehousing: 'Warehousing',
    inputName: 'Please enter item name',
    inputNumber: 'Please enter item quantity',
    successMsg: 'Added successfully',
    editSuccessMsg: 'Modified successfully',
    time: 'Time',
    operation: 'Operation',
    deleteP: 'Delete item information',
    isDeleteP: 'Delete current item information',
    successDelMsg: 'Delete succeeded',
    price: 'Item price',
    inputPrice: 'Please enter item price',
    qualityDate: 'quality guarantee period',
    date: 'date',
    exSuccess: 'Issue succeeded',
    waSuccess: 'Warehousing succeeded',
    overdue: 'Be overdue',
    consume: 'Consume',
    unitTitle: 'Item unit',
    addUnit: 'New unit',
    editUnit: 'Editing unit',
    unitName: 'Unit name',
    unitsymbol: 'Unit symbol',
    unitInputName: 'Please enter company name',
    unitInputsymbol: 'Please enter unit symbol',
    deleteUnitP: 'Delete unit',
    isDeleteUnitP: 'Delete current company information',
    nodatamsg: 'There is no data, please go to the item unit table to add',
    barCode: 'Bar Code',
    find: 'See',
    itemdetail: 'Details',
  },
  tax: {
    name: "Taxation",
    add: "Add",
    delete: "Delete",
    PleaseTaxName: "Please enter the tax name",
    PleaseTaxPrice: "Please enter tax rate",
  },
  invoice: {
    titile: "Invoice Data",
    pleaseInput: "Please enter",
    unifiedNumber: "Unified numbering",
    postMachineCode: "Post machine code",
    postMachineSerialNumber: "Post machine serial number",
    productName: "Product name",
    authenticator: "Authenticator",
    storeCode: "Store code",
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/en.js